/**充值**/
<template>
  <div class="recharge">
    <div class="inform clear">
      <div class="list">
        <span class="text">账户</span>
        <span class="val">{{data.userNo}}</span>
      </div>
      <div class="list">
        <span class="text">姓名</span>
        <span class="val">{{data.userName}}</span>
      </div>
    </div>
    <div class="selectSum">
      <h2>
        账户余额：
        <span
          class="val">{{postCustomerPreSave.present_balance ? postCustomerPreSave.present_balance.toFixed(1) : '00.0'}}</span>
        <span class="unit">元</span>
      </h2>
      <div class="content">
        <div class="default clear">
          <span class="tab" v-for="(itme,index) in seletSum" @click="selectSumFn(index,itme.val)"
                :class="seletSumNum==index?'tabAc':''">{{itme.name}}</span>
        </div>
        <div class="customSum">
          <input placeholder="自定义充值金额（≥100元）" v-model="credit" @input="customSumFn"/>
        </div>
      </div>
    </div>
    <div class="payType">
      <h2>支付方式</h2>
      <div class="content">
        <div class="row" @click="payTypeFn(0)">
          <span class="text">微信支付</span>
          <span class="select" :class="payTypeNum==0?'selectAc':''">
            <i class="iconfont icon-chenggong"></i>
          </span>
        </div>
        <div class="row" @click="payTypeFn(1)" v-if="false">
          <span class="text">银联支付</span>
          <span class="select" :class="payTypeNum==1?'selectAc':''">
            <i class="iconfont icon-chenggong"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="rechargeBut" :class="credit!==''&&Number(credit)>0?'rechargeButShow':''" @click="userSumPayFn">
      <span>立即充值</span>
    </div>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkHintBox from '../module/hintBox/src/hintBox.vue'

  export default {
    components: {XkHintBox},
    name: 'recharge',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        postCustomerPreSave: 'postCustomerPreSave'
      })
    },
    data () {
      return {
        data: { // 用户信息
          userNo: '', // 用户电话
          userName: '' // 用户名称
        },
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        },
        seletSum: [
          {
            name: '100元',
            val: '100'
          },
          {
            name: '300元',
            val: '300'
          },
          {
            name: '500元',
            val: '500'
          },
          {
            name: '1000元',
            val: '1000'
          }
        ], // 充值金额选择
        seletSumNum: 0, // 充值选择序号
        credit: '100', // 充值金额
        payTypeNum: 0 // 支付方式序号
      }
    },
    methods: {
      postCustomerPreSaveFn () { // 获取 用户余额
        let that = this
        that.$store.dispatch('postCustomerPreSave', {
          id: that.loginData.passenger.id
        })
      },
      selectSumFn: function (index, val) { // 选择金额
        this.seletSumNum = index
        this.credit = val
      },
      customSumFn: function () { // 输入金额
        let that = this
        for (let i = 0; i < that.seletSum.length; i++) {
          if (that.credit === that.seletSum[i].val) {
            that.seletSumNum = i
            return
          } else {
            that.seletSumNum = null
          }
        }
      },
      payTypeFn: function (val) { // 支付方式
        this.payTypeNum = val
      },
      userSumPayFn: function () {
        let that = this
        if (Number(that.credit) >= 100) {
          that.$store.dispatch('userSumPay', {
            'money': that.credit,
            'open_id': window.configure.open_id,
            fn: (data) => {
              if (data === '充值成功') {
                that.hintBox = {
                  stateShow: true,
                  state: 'yes',
                  content: '充值成功！'
                }
                setTimeout(() => {
                  that.hintBox.stateShow = false
                }, 1500)
              } else {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: '充值失败！'
                }
                setTimeout(() => {
                  that.hintBox.stateShow = false
                }, 1500)
              }
            }
          })
        } else {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '充值金额不能少于100元'
          }
          setTimeout(() => {
            that.hintBox.stateShow = false
          }, 1500)
        }
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.data = {
            userNo: that.loginData.passenger.phone,
            userName: that.loginData.passenger.name
          }
          that.postCustomerPreSaveFn()
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .recharge {
    width: 100vw;
    height: 100vh;
    background-color: #f3f4f5;
    box-sizing: border-box;
    padding: 1rem;
    .inform {
      width: 100%;
      box-sizing: border-box;
      padding: 0 1rem;
      background-color: #fff;
      margin-bottom: 1rem;
      border-radius: 0.333rem;
      overflow: hidden;
      height: 2.9rem;
      line-height: 2.9rem;
      .list {
        width: 60%;
        box-sizing: border-box;
        float: left;
        padding-left: 1rem;
        .text {
          font-size: 1rem;
          color: #333333;
          text-align: left;
          width: 3rem;
        }
        .val {
          font-size: 0.8333rem;
          color: #999999;
          width: calc(~'100% - 4.5rem');
        }
      }
      .list:nth-child(2) {
        width: 40%;
        padding-left: 0;
        .text {
          text-align: left;
          width: 3rem;
        }
      }
    }
    .selectSum {
      box-sizing: border-box;
      background-color: #fff;
      width: 100%;
      border-radius: 0.333rem;
      padding: 0 1rem;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
      h2 {
        font-size: 1rem;
        line-height: 2.9166rem;
        border-bottom: 1px solid #eeeeee;
        padding-left: 1rem;
        .val {
          color: #f06553;
          margin: 0 0.5rem;
        }
        .unit {
          color: #999;
        }
      }
      .content {
        box-sizing: border-box;
        width: 100%;
        padding: 1rem;
        .default {
          margin-bottom: 0.5rem;
          .tab {
            box-sizing: border-box;
            width: calc(~'25% - 0.5rem');
            font-size: 0.833rem;
            color: #333333;
            line-height: 2.833rem;
            height: 2.8333rem;
            border-radius: 0.333rem;
            border: 1px solid #eee;
            text-align: center;
            margin-right: 0.5rem;
            float: left;
            transition: 0.3s all;
            margin-bottom: 0.5rem;
          }
          .tabAc {
            background-color: #f06553;
            color: #fff;
            border-color: #f06553;
          }
        }
        .customSum {
          height: 3.666rem;
          line-height: 3.666rem;
          border: 1px solid #eee;
          width: 100%;
          border-radius: 0.333rem;
          overflow: hidden;
          input {
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 0 0.5rem;
            border: none;
            font-size: 0.8333rem;
          }
        }
      }
    }
    .payType {
      box-sizing: border-box;
      width: 100%;
      background-color: #fff;
      padding: 0 1rem;
      margin-bottom: 1rem;
      border-radius: 0.333rem;
      h2 {
        font-size: 1rem;
        line-height: 2.9166rem;
        border-bottom: 1px solid #eeeeee;
        padding-left: 1rem;
      }
      .content {
        .row {
          display: inline-block;
          box-sizing: border-box;
          width: 100%;
          height: 3.666rem;
          line-height: 3.666rem;
          border-bottom: 1px solid #eee;
          padding-left: 1rem;
          position: relative;
          .text {
            padding-left: 1.8rem;
            display: inline-block;

          }
          .select {
            float: right;
            width: 1.166rem;
            height: 1.166rem;
            border: 1px solid #eee;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: middle;
            position: absolute;
            right: 1rem;
            top: 50%;
            transform: translate(0, -50%);
            i {
              font-size: 0.5rem;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              opacity: 0;
            }
          }
          .selectAc {
            background-color: #f06553;
            border-color: #f06553;
            color: #fff;
            i {
              opacity: 1;
            }
          }
        }
        .row:nth-child(1) {
          .text {
            background: url(../../assets/img/recharge/wx.png) no-repeat left center;
            background-size: 1.475rem 1.3rem;
          }
        }
        .row:nth-child(2) {
          .text {
            background: url(../../assets/img/recharge/yinlian.png) no-repeat left center;
            background-size: 1.375rem 1.3rem;
          }
        }
        .row:nth-last-child(1) {
          border: none;
        }
      }
    }
    .rechargeBut {
      span {
        width: 100%;
        border-radius: 0.333rem;
        background-color: #e1e1e1;
        color: #cbcbcb;
        height: 3.75rem;
        line-height: 3.75rem;
        text-align: center;
        font-size: 1rem;
        transition: 0.3s all;
      }
    }
    .rechargeButShow {
      span {
        background-color: #f06553;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// recharge.vue?6b6d3078